<footer class="eclaim-footer">
    <div class="eclaim-footer__contact">
        <p>{{ 'FOOTER.CONTACT_MESSAGE' | translate }}</p>
        <a href="https://www.manulife.co.jp/ja/individual/contact.html" class="eclaim-footer__link" target="_blank" rel="noopener noreferrer">
            <span class="eclaim-footer__link-underline">{{ 'FOOTER.CONTACT_LINK' | translate }}</span>
        </a>
    </div>
    <div class="eclaim-footer__divider"></div>
    <div class="eclaim-footer__policy">
        <a class="eclaim-footer__policy__privacy" href="https://www.manulife.co.jp/privacypolicy" target="_blank">{{ 'FOOTER.PRIVACY_POLICY' | translate }}</a>
        <p class="eclaim-footer__policy__copyright">{{ 'FOOTER.COPYRIGHT' | translate }}</p>
    </div>
</footer>